import styled, { css } from 'styled-components';

import { CommonAction, recipesCommonAction, styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './SweepSheet.tokens';

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    letter-spacing: -0.02em;
`;

///
/// Top-level sections

export const MainInterior = styled.div`
    display: grid;
    gap: ${tokens.section.gap}px;
    padding-bottom: ${tokens.section.gap}px;
`;

export const FooterInterior = styled.div`
    display: grid;
    gap: ${tokens.section.gap}px;
`;

///
/// Nested sections

export const SectionHeader = styled.div`
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
`;

export const SectionHeaderTitle = styled.p`
    ${typographyBase};
    font-size: ${tokens.section.titleSize}px;
    font-weight: 700;
`;

export const ClearAction = styled(CommonAction)`
    ${recipesCommonAction.essential};
    padding: ${tokens.clearAction.padding}px;
    font-size: ${tokens.clearAction.fontSize}px;
    font-weight: 700;
    background-color: transparent;
    border-radius: ${tokens.clearAction.radius}px;

    &:disabled {
        opacity: 0.8;
    }

    &:hover {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.06);
    }
`;

export const CartList = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.section.gap}px;
`;

export const CartItem = styled.li`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: ${tokens.section.gap / 2}px;
`;

export const Summary = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: ${tokens.summary.gap}px;
`;

export const SummaryTitle = styled.p`
    ${typographyBase};
    font-size: ${tokens.summary.titleSize}px;
    font-weight: 600;
`;
